import { exists } from '@/api'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'

export interface BibliographyContentDetailBibliography {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SearchType
  displayTitle: string
  bibliographyRealId: number
  collectionFlag: CollectionFlag
  revision: number
}

export function BibliographyContentDetailBibliographyFromJSON(
  json: any
): BibliographyContentDetailBibliography {
  return {
    bibliographyClass: json.bibliography_class,
    prefix: json.prefix,
    bibliographyId: json.bibliography_id,
    searchType: json.search_type,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    bibliographyRealId: json.bibliography_real_id,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : null,
    revision: json.revision
  }
}

export const defaultBibliographyContentDetailBibliography = (): BibliographyContentDetailBibliography => ({
  bibliographyClass: BibliographyClass.Real,
  prefix: Prefix.Real,
  bibliographyId: 0,
  searchType: SearchType.Book,
  displayTitle: '',
  bibliographyRealId: 0,
  collectionFlag: null,
  revision: 0
})
